import ApplicationAdapter from './application';

export default class HomeScreenAdapter extends ApplicationAdapter {
  urlForQuery(query: Record<string, unknown>) {
    const hotelId = query['hotel_id'];

    if (hotelId === undefined || hotelId === null || hotelId === '') {
      throw new Error('home-screen queries require a `hotel_id`');
    }

    const host = this.host.replace(/\/$/, '');

    delete query['hotel_id'];

    return `${host}/user/hotels/${String(hotelId)}/home_screens`;
  }
}

declare module 'ember-data/types/registries/adapter' {
  export default interface AdapterRegistry {
    'home-screen': HomeScreenAdapter;
  }
}
